<template>
    <v-form
        v-model="valid"
        ref="form"
        v-on:submit="submit"
        :id="id + '-form'"
        >

        <slot></slot>

        
        
        <!-- 
            <v-spacer v-if="hasFooter"></v-spacer>
            <slot name="footer"></slot> 
        -->
        
    </v-form>
</template>
<script lang="ts">
import InisoftTextInput from '@/components/forms/Inputs/InisoftTextInput.vue';
export default {
    props: ["id", "header", "hasFooter"],
    components: {
        InisoftTextInput
    },
    methods: {
        async submit(evt: Event) {
            evt.preventDefault()
            const form = this.$refs.form as any;
            console.log('InisoftForm submit - form ref:', form);
            const validationResult = await form.validate();
            console.log('InisoftForm submit - validation result:', validationResult);
            this.$emit("submitted", validationResult)
        }
    },
    data() {
        return {
            valid: false
        }
    }
}
</script>

<style lang="scss">
    
</style>